import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-no-records',
    template: `
        <div *ngIf="!isLoaded;else completed" class="spinner spinner-primary text-center" style="margin: 0 auto;display: block"></div>
        <ng-template #completed>
            <div class="card card-ecommerce-1 mb-4">
                <div class="card-body text-center">
                    <i class="i-Empty-Box mb-2"></i>
                    <h1 class="text-primary" translate>EMPTY.TITLE</h1>
                    <h4 class="text-primary" translate>EMPTY.MESSAGE</h4>
                    <ng-container *ngIf="!disableAdd">
                        <h5 class="text-primary" translate>EMPTY.TRY-ADD-NEW</h5>
                        <button class="btn btn-primary" [routerLink]="['add']" translate><span class="fa fa-plus-circle"></span></button>
                    </ng-container>
                </div>
            </div>
        </ng-template>`
})
export class NoRecordsComponent {
    isLoaded = false;
    @Input() disableAdd = false;

    constructor() {
        setTimeout(() => this.isLoaded = true, 2120);
    }

}
